import {API_URL, apiGet} from '../api'

// GET /v3/admin/feed_template/kinds — 에디터 계약(kind별 변수·공통 변수·style·블록 타입) 단일 소스.
export const getFeedTemplateKinds = async () => {
    return await apiGet(API_URL, 'admin/feed_template/kinds')
}
